import { Avatar } from '@pega/cosmos-react-core';
import type { MenuItemProps } from '@pega/cosmos-react-core';

// cspell:disable
export const demoUsers: MenuItemProps[] = [
  {
    id: 'turnc',
    primary: 'Cindy Turner',
    secondary: ['Lead Engineer'],
    visual: <Avatar size='l' name='Cindy Turner' />
  },
  {
    id: 'deans',
    primary: 'Seth DeAngelo',
    secondary: ['Senior Software Engineer', 'Backend Developer'],
    visual: <Avatar size='l' name='Seth DeAngelo' />
  },
  {
    id: 'moorj',
    primary: 'Janet Moore',
    secondary: ['Backend Developer'],
    visual: <Avatar size='l' name='Janet Moore' />
  },
  {
    id: 'thomd',
    primary: 'Dean Thomas',
    secondary: ['Designer'],
    visual: <Avatar size='l' name='Dean Thomas' />
  },
  {
    id: 'hathb',
    primary: 'Bob Hathoway',
    secondary: ['Lead Designer', 'Product Owner'],
    visual: <Avatar size='l' name='Bob Hathoway' />
  }
];
// cspell:enable
